import type { UserCreationNextStep, UserCreationSuccess, UserDraft } from '@/types/userCreation';

export function buildUserCreationDisplayName(draft: UserDraft): string {
  return `${draft.firstName} ${draft.lastName}`.trim();
}

/** e.g. Priya Venkatesh · priya.venkatesh@assaabloy.com · 26-bit Standard · 00036 */
export function buildUserCreationSummaryLine(draft: UserDraft): string {
  const userName = buildUserCreationDisplayName(draft) || '—';
  const email = draft.email.trim() || '—';
  const format = draft.cardFormat.trim() || '—';
  const number = draft.cardNumber.trim() || '—';
  return `${userName} · ${email} · ${format} · ${number}`;
}

export function buildUserCreationNextSteps(draft: UserDraft): UserCreationNextStep[] {
  const displayName = buildUserCreationDisplayName(draft);
  const openLabel = draft.firstName.trim()
    ? `Open ${draft.firstName.trim()}`
    : displayName
      ? `Open ${displayName.split(/\s+/)[0]}`
      : 'Open user';

  return [
    { id: 'open-user', label: openLabel },
    { id: 'add-credential', label: 'Add another credential' },
    { id: 'add-user', label: 'Add another user' },
    { id: 'edit-credential', label: 'Edit credential for this user' },
    { id: 'edit-details', label: 'Edit user details' },
  ];
}

export function buildUserCreationSuccessResult(draft: UserDraft): UserCreationSuccess {
  const userName = buildUserCreationDisplayName(draft) || 'User';
  return {
    userName,
    summaryLine: buildUserCreationSummaryLine(draft),
    nextSteps: buildUserCreationNextSteps(draft),
  };
}
